import axios from "axios"

const SURVEYS_URL = "https://surveys.idexo.io"

export const api = {
    getSurveys: async (limit, startKey) => {
        const config = {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                limit: limit,
                startKey: startKey
            }
        }
        try {
            let response = await axios.get(SURVEYS_URL, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    }
}
